import React from "react";
import { MenuOrderSettingsPanel, useMobileNavigationOrder } from "components/navbar/MenuOrderSettings";

const MenuOrder = () => {
  const { visibleRoutes, mobileOrderIds, setMobileOrderIds, saving, saveMobileOrder } = useMobileNavigationOrder();

  return (
    <div className="rounded-3xl border border-gray-200 bg-white p-6 shadow-sm dark:border-white/10 dark:bg-navy-800">
      <div className="mb-4">
        <h1 className="text-2xl font-bold text-navy-700 dark:text-white">Menu order</h1>
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
          Manage the order of your sidebar menu items for this account.
        </p>
      </div>
      <MenuOrderSettingsPanel
        mobileOrderIds={mobileOrderIds}
        visibleRoutes={visibleRoutes}
        onOrderChange={setMobileOrderIds}
        onSave={saveMobileOrder}
        onClose={() => {}}
        saving={saving}
      />
    </div>
  );
};

export default MenuOrder;
